import { useIntl } from "react-intl";

import { useSiteActivationContext } from "../../hooks";
import { SubmitButton } from "../common/submit-button";

export const UpgradeEligibleSubmitButton = () => {
    const { formatMessage } = useIntl();
    const { showSitePicker } = useSiteActivationContext();

    const submitMessage = showSitePicker
        ? formatMessage({
              id: "WacSignupForm.upgradeButtonText",
              defaultMessage: "Upgrade now"
          })
        : formatMessage({
              id: "siteActivation.nameSiteNewUser.continueButton",
              defaultMessage: "Continue"
          });

    return <SubmitButton submitMessage={submitMessage} />;
};
